module.exports = __webpack_public_path__ + "img/person-1.7904ba15.jpg";